import axios from "axios";

const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_URL,
  cancelToken: axios.CancelToken.source().token,
});

instance.interceptors.request.use(
  (config) => {
    // ดึง token จาก local storage
    const token = localStorage.getItem("token");
    if (token) {
      // ถ้ามี token, เพิ่มเข้าไปใน header ของ request
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    // จัดการกับ error ในกรณีที่มีปัญหาเกิดขึ้นก่อนส่ง request
    return Promise.reject(error);
  }
);

export default instance;
